import React, { useState, useEffect, useRef } from 'react';
import Applycredit from './applycredit'
import partsService from "../../../../services/partsservice";
import helperfunctions from "../../../../utils/helperfunctions";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { IContainerProps } from './applycreditinterface';
import { selectors as globalDataSelector } from "../../../../state/features/common/globaldata";
import { useSelector } from "react-redux";
import { process } from '@progress/kendo-data-query';
import { selectors as headerSelector } from "../../../../state/features/header";
import { ICartContextType } from '../shoppingcartpromointerface';
import { useCartContext } from '../../shoppingcart';

const ApplyCreditContainer = (props: IContainerProps) => {
  const { t } = useTranslation();
  let creditDataRefs = useRef<any>([]);
  const { cartsDetails }: ICartContextType = useCartContext();

  const [creditInput, setCreditInput] = useState<any>('0');
  const [availablePartsCredits, setAvailablePartsCredits] = useState({ loading: false, data: [] });
  const [creditList, setCreditList] = useState<any>({ data: [], total: 0 });
  const [popUpInfo, setPopUpInfo] = useState<any>({ creditInput: 0, subTotal: 0, eligibleCredit: 0, errMsg: '', appliedCredit: 0, maxCreditEligible: 0, total: 0, selectedCredit: {} });
  const [isCreditApplied, setIsCreditApplied] = useState(false);
  const [selectedCreditInfo, setSelectedCreditInfo] = useState<any>([]);
  const [continuePartsCreditResponse, setContinuePartsCreditResponse] = useState({ loading: false, data: {} });

  const { headercurrentuser, globalData }: any = useSelector((state) => ({
    headercurrentuser: headerSelector.currentuser(state),
    globalData: globalDataSelector.globaldata(state),
  }));

    useEffect(() => {
    if (props?.appliedCreditInfo?.selectedCredit) {
        let creditList = [{ [props?.appliedCreditInfo?.selectedCredit?.id]: true }];
        setSelectedCreditInfo(creditList)
    } else {
      setSelectedCreditInfo([])
    }
  }, [props?.appliedCreditInfo?.selectedCredit])

    useEffect(() => {
    if (availablePartsCredits?.data?.length) {
        mapCreditListToRef(availablePartsCredits?.data);
        if (props?.appliedCreditInfo?.appliedCredit) {
           onApplyPartsCredit(true);
        }
    }
  }, [availablePartsCredits]);

  useEffect(() => {
    if (props?.appliedCreditInfo?.appliedCredit) {
      setIsCreditApplied(true);
    }
  }, [props?.appliedCreditInfo?.appliedCredit])

    useEffect(() => {
    const item = props?.itemSummaryDetails?.data;
    const customerCredit = props?.customerCreditInfo?.data;
    const subTotal = item?.total ?? 0
    const eligibleCredit = customerCredit?.eligibleAmount ? Number(customerCredit?.eligibleAmount) : 0;
    const input = Math.min(subTotal, eligibleCredit, customerCredit?.remainingCredit);
    const val = props?.appliedCreditInfo?.appliedCredit ? props?.appliedCreditInfo?.appliedCredit : Math.floor((input ? Number(input) : 0) * 100) / 100;
    setCreditInput(val);
    setPopUpInfo({
      ...popUpInfo, creditInput: val, subTotal, eligibleCredit: Math.floor(eligibleCredit * 100) / 100, total: item?.total,
      errMsg: '', appliedCredit: props?.appliedCreditInfo?.appliedCredit ? Number(props?.appliedCreditInfo?.appliedCredit) : 0, maxCreditEligible: input
    })
    }, [props?.itemSummaryDetails, props?.customerCreditInfo, props?.appliedCreditInfo]);

  const getAvailablePartsCredits = async (customerId: number) => {
    try {
      setAvailablePartsCredits({ loading: true, data: [] });
      const response = await partsService.getAvailablePartsCredits(customerId);
      if (response?.isSuccess) {
          setAvailablePartsCredits({ loading: false, data: response?.data ?? {} });
          let creditList: any[] = [];
          let selectedCreditList: any[] = [];
          let remainingBalanceSum = 0;
          let requiredBalance = props?.appliedCreditInfo?.total;
          const itemSummary = props?.itemSummaryDetails?.data;
          let availableCreditThatMatchRequiredBal = response?.data?.find((s: any) => s.remainingKomatsuCredit > props?.appliedCreditInfo?.total);
          response?.data?.forEach((t: any) => {
              remainingBalanceSum += t.remainingKomatsuCredit;
              if ((itemSummary?.isKomatsuCreditApplied && itemSummary?.komatsuCreditEntryId?.indexOf(t.creditEntryIdGroup) > -1)) {
                  creditList[t.creditEntryIdGroup] = true;
                  selectedCreditList.push(t);
              }
              else if (!itemSummary?.isKomatsuCreditApplied && requiredBalance > 0 && ((requiredBalance <= t.remainingKomatsuCredit) || !availableCreditThatMatchRequiredBal))
              {
                  requiredBalance = requiredBalance - t.remainingKomatsuCredit;
                  creditList[t.creditEntryIdGroup] = true;
                  selectedCreditList.push(t);
              }
          })
          props?.updateSelectedCredit(selectedCreditList);
          setSelectedCreditInfo(creditList);
      } else {
        setAvailablePartsCredits({
          loading: false, data: []
        });
        console.error('Error in getAvailablePartsCredits - ', response?.msg);
      }
    } catch (error) {
      setAvailablePartsCredits({
        loading: false, data: []
      });
      console.error('Exception in getAvailablePartsCredits - ', error);
    }
  };

  useEffect(() => {
    if (globalData.CustomerId) {
      const customerId = globalData?.CustomerId ? parseInt(globalData?.CustomerId) : 0;
      getAvailablePartsCredits(customerId);
    }
  }, [globalData?.CustomerId]);

    const onCreditInputChange = (value: string) => {
    setIsCreditApplied(false);
    let input: any = 0; let info: any = {};
    if (value) {
      const isValid = /^(\d+)?(\.\d{0,2})?$/.test(value);
      if (isValid) {
        if (Number(value) <= 999999999) {
          input = value;
          info = { ...popUpInfo, creditInput: value }
        } else {
          input = creditInput;
          info = { ...popUpInfo, creditInput }
        }
      } else {
        input = creditInput;
        info = { ...popUpInfo, creditInput }
      }
    } else {
      input = value == '0' ? '0' : '';
      info = { ...popUpInfo, creditInput: value == '0' ? '0' : '' }
    }
    setCreditInput(input);
    setPopUpInfo(info);
    props?.updateApplyCreditRes({ loading: false, data: {} });
  };

  const onCloseAlert = () => {
    setPopUpInfo({ ...popUpInfo, errMsg: '' });
  };

    const checkCreditApplied = (isInitial = false) => {
    const inputNum = creditInput ? Number(creditInput) : 0
    const appliedCredit = props?.appliedCreditInfo?.appliedCredit ?? 0;
    const creditApplied = isInitial ? appliedCredit : inputNum;
    const { eligibleCredit, total } = popUpInfo;
    const eligibleCreditValueNearest = Math.min(eligibleCredit, (total + appliedCredit));
    const eligibleCreditValue = Math.round(eligibleCreditValueNearest * 100) / 100;
    const remainingKomatsuCredit = props?.selectedCredit?.length > 0 ? (props?.selectedCredit?.reduce((n:any, t: any) => n + t.remainingKomatsuCredit, 0) ?? 0) : 0;
    let message = '';
    let isValid = true;
    if (!availablePartsCredits?.data?.length) {
      message = t(RESOURCE.MyK_Label_ShoppingCart_No_Credits_Available)
      isValid = false;
    } else if (creditApplied <= 0) {
      message = t(RESOURCE.MyK_Label_ShoppingCart_Greater_Than_Zero)
        isValid = false;
    } else if ((!isInitial && creditApplied > eligibleCreditValue) || (isInitial && creditApplied > eligibleCredit)) {
      message = t(RESOURCE.MyK_Label_ShoppingCart_Enter_Lower_Amount)
      isValid = false;
    } else if (props?.selectedCredit?.length <= 0) {
      message = t(RESOURCE.MyK_Label_ShoppingCart_Select_Komatsu_Credit)
      isValid = false;
    } else if (creditApplied > remainingKomatsuCredit) {
      message = t(RESOURCE.MyK_Label_ShoppingCart_Select_Additional_Credit)
      isValid = false;
    } else if (creditApplied > props?.customerCreditInfo?.data?.remainingCredit) { //greater than available credit
      message = t(RESOURCE.MyK_Label_Greater_Than_Available_Credit)
      isValid = false;
    }
    setPopUpInfo({ ...popUpInfo, errMsg: message });
    return isValid;
  };

  const onContinuePartsCredit = async () => {
    try {
      setContinuePartsCreditResponse({ loading: true, data: {} });
      const reqBody = {
        userAadId: headercurrentuser?.azureADId,
        cartId: cartsDetails?.cart?.cartId,
        creditApplied: creditInput ? Number(creditInput) : 0,
        creditEligibility: popUpInfo?.eligibleCredit ?? 0,
        creditEntryIds: `${props?.selectedCredit?.map((t: any) => t.creditEntryIdGroup)?.join("~")}`
      }
      props?.updateApplyCreditRes({ loading: false, data: {} });
      const response = await partsService.continuePartsCredit(reqBody);
      if (response?.isSuccess) {
        if (response?.data?.isSuccessful) {
          props?.getItemSummaryDetails();
          const customerId = globalData?.CustomerId ? parseInt(globalData?.CustomerId) : 0;
          props?.getCustomerCreditInfo(customerId);
          setContinuePartsCreditResponse({ loading: false, data: response?.data });
          props?.applyOnClick();
          helperfunctions.showSuccessMessage(`${response?.data?.message}`);
        } else {
          setContinuePartsCreditResponse({ loading: false, data: response?.data });
          helperfunctions.showErrorMessage(`${response?.data?.message}`);
        }
      } else {
        setContinuePartsCreditResponse({
          loading: false, data: {}
        });
        helperfunctions.showErrorMessage(`${response?.msg}`);
      }
    } catch (error) {
      setContinuePartsCreditResponse({
        loading: false, data: {}
      });
      helperfunctions.showErrorMessage(`${error}`);
    }
  }

    const onApplyPartsCredit = async (isInitial = false) => {
    try {
      const isValid = checkCreditApplied(isInitial);
      if (isValid) {
        props?.updateApplyCreditRes({ loading: true, data: {} });
        const response = await partsService.applyPartsCredit({
         creditEntryIds: `${props?.selectedCredit?.map((t: any) => t.creditEntryIdGroup)?.join(",")}`,
         creditApplied: `${Number(creditInput ?? 0)}`
        });
        if (response?.isSuccess) {
          setIsCreditApplied(true);
          props?.updateApplyCreditRes({ loading: false, data: { isSuccess: true, ...response?.data } });
        } else {
          props?.updateApplyCreditRes({
            loading: false, data: {}
          });
          helperfunctions.showErrorMessage(`${t(RESOURCE.MyK_Label_ShoppingCart_onApplyCredit_Error_Msg)} - ${response?.msg}`);
        }
      }
    } catch (error) {
      props?.updateApplyCreditRes({
        loading: false, data: {}
      });
      helperfunctions.showErrorMessage(`${t(RESOURCE.MyK_Label_ShoppingCart_onApplyCredit_Error_Msg)} - ${error}`);
    }
  };



  const creditTableColumn = [
    {
      field: 'creditUsage',
      title: t(RESOURCE.MyK_Label_ShoppingCart_Credit_Usage),
      columnMenu: 'ColumnMenu',
      sortable: true
    },
    {
      field: 'totalKomatsuCreditAmt',
      title: t(RESOURCE.MyK_Label_ShoppingCart_Credit_Amount),
      columnMenu: 'ColumnMenu',
      sortable: true,
      filter: "numeric",
      format: "{0:n2}",
      width: 160,
      cell: (row: any) => { return <td>${helperfunctions.formatAmount(row?.dataItem?.totalKomatsuCreditAmt)}</td> }
    },
    {
      field: 'remainingKomatsuCredit',
      title: t(RESOURCE.MyK_Label_ShoppingCart_Balance),
      columnMenu: 'ColumnMenu',
      sortable: true,
      filter: "numeric",
      format: "{0:n2}",
      width: 140,
      cell: (row: any) => { return <td>${helperfunctions.formatAmount(row?.dataItem?.remainingKomatsuCredit)}</td> }
    },
    {
      field: 'durationDisplay',
      title: t(RESOURCE.MyK_Label_ShoppingCart_Duration),
      columnMenu: 'ColumnMenu',
      sortable: true,
      width: 160,
    }
  ]

    const mapCreditListToRef = (list: any) => {
    if (list?.length) {
      list?.map((item: any, index: any) => {
        creditDataRefs.current[index] = {
          "index": index,
          "id": item.creditEntryIdGroup,
          ...item
        };
      });
      const processedData = process(creditDataRefs?.current, {
        sort: [],
        filter: { logic: 'and', filters: [] },
        group: [],
        skip: 0,
        take: 10,
      });
      setCreditList({
        data: processedData?.data,
        total: processedData?.total
      });
    }
  }

    const getSelectedValue = (values: any) => {
    let creditList = values.map((item: any) => {
      return creditDataRefs?.current[item?.index]
    });
    setIsCreditApplied(false);
    props?.updateSelectedCredit(creditList??[]);
  }

  const incrementCount = () => {
    if (Number(creditInput) <= 999999999) {
      onCreditInputChange((Number(creditInput) + 1).toString());
    }
  }

  const decrementCount = () => {
    if (creditInput === '') {
      onCreditInputChange('0');
    } else {
      onCreditInputChange((Number(creditInput) - 1).toString());
    }
  };

  return (
    <Applycredit
      onCreditInputChange={onCreditInputChange}
      creditInput={creditInput}
      onApplyPartsCredit={onApplyPartsCredit}
      applyCreditResponse={props?.applyCreditResponse}
      applyOnClick={props?.applyOnClick}
      availableCreditAmount={props?.availableCreditAmount}
      getSelectedValue={getSelectedValue}
      creditList={creditList}
      creditTableColumn={creditTableColumn}
      onContinuePartsCredit={onContinuePartsCredit}
      itemSummaryDetails={props?.itemSummaryDetails}
      customerCreditInfo={props?.customerCreditInfo}
      popUpInfo={popUpInfo}
      incrementCount={incrementCount}
      decrementCount={decrementCount}
      onCloseAlert={onCloseAlert}
      selectedCredit={props?.selectedCredit}
      isCreditApplied={isCreditApplied}
      availablePartsCredits={availablePartsCredits}
      selectedCreditInfo={selectedCreditInfo}
      appliedCreditInfo={props?.appliedCreditInfo}
      updateApplyCreditRes={props?.updateApplyCreditRes}
      continuePartsCreditResponse={continuePartsCreditResponse}
    />
  )
}

export default ApplyCreditContainer